var map = {
	"./btn1s.png": "646c",
	"./btn2s.png": "8472",
	"./btn3s.png": "ed40",
	"./btn4s.png": "441f",
	"./btn5s.png": "3591",
	"./btn6s.png": "cecd",
	"./btn7s.png": "608e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fda2";